import './index.scss';
import React, { useState } from 'react';
import ImageViewer from 'react-wx-images-viewer';

const ImageView = (props) => {
    const { url, ...other } = props;
    const [ viewer, setViewer ] = useState(false);
    
    return (
      <>
        <img onClick={() => setViewer(true)} src={url} { ...other } crossOrigin="anonymous" alt="图"/>
        {
          viewer &&
          <ImageViewer
            urls={[url]}
            onClose={() => setViewer(false)}
            zIndex={10000}
            >
          </ImageViewer>
        }
      </>
    )
}

export default ImageView;